var fieldBoxContent = 'fx_2d2fb1e5_80ssm90';

export { fieldBoxContent };
//# sourceMappingURL=content.vanilla.mjs.map
